// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media (min-width:768px){.community-header__thumbnail{box-shadow:32px 0 32px #000;max-width:720px;max-height:200px}.community-header__thumbnail:after{content:\" \";top:0;left:0;position:absolute;height:100%;width:100%;display:block;background-image:linear-gradient(270deg,transparent 50%,#222)}.community-header__container-info{overflow:hidden;width:301px;z-index:1;text-shadow:1px 0 #222,0 -1px #222,-1px 0 #222,0 1px #222}}", ""]);
// Exports
module.exports = exports;
